import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueApexCharts from 'vue-apexcharts'
import VueExcelXlsx from "vue-excel-xlsx";
import store from './store';
import JwPagination from 'jw-vue-pagination';
import VueQRCodeComponent from 'vue-qrcode-component'
import VueHtml2Canvas from 'vue-html2canvas';
import 'regenerator-runtime';
import "vue-toastification/dist/index.css";
import Toast from "vue-toastification";
import Vue2Editor from "vue2-editor";

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false
Vue.use(Toast);

Vue.use(VueExcelXlsx);
Vue.component('jw-pagination', JwPagination);
Vue.component('pulse-loader', require('vue-spinner/src/PulseLoader.vue'));
Vue.component('qr-code', VueQRCodeComponent)
Vue.use(VueHtml2Canvas);
Vue.use(Vue2Editor);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
